"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stripProfileOfValueTypes = exports.isTouched = exports.ProfileProvider = exports.ProfileContext = exports.ProfileActionsContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _usePersistentReducer3 = _interopRequireDefault(require("@jobmatchme/library-utils/es/hooks/usePersistentReducer"));

var _ConfigProvider = require("../ConfigProvider");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var isTouched = function isTouched(value) {
  return Array.isArray(value.touched) ? value.touched.length > 0 : value.touched;
};

exports.isTouched = isTouched;

var testFunnelCompleted = function testFunnelCompleted(profileObject) {
  return Object.values(profileObject).filter(isTouched).length > 0;
};

var isStepType = function isStepType(object) {
  return 'componentConfiguration' in object && object.componentConfiguration !== '';
};

var validateEditConfig = function validateEditConfig(config) {
  // The config MUST contain an edit configuration
  if (!config || !config.edit) {
    throw Error("Unable to get edit configuration from provided config. Make sure to configure the edit view");
  } // The edit configuration MUST NOT contain any properties, that are not configured in the funnel


  var editValueNames = config.edit.filter(function (step) {
    return isStepType(step) && !step.disabled;
  }).map(function (step) {
    if (!isStepType(step)) {
      return '';
    }

    if (!!!config.componentConfigurations[step.componentConfiguration]) {
      throw Error("Invalid component configuration for key \"".concat(step.componentConfiguration, "\""));
    }

    return config.componentConfigurations[step.componentConfiguration].valueName;
  });
  var funnelValueNames = config.funnel.flatMap(function (_ref) {
    var steps = _ref.steps;
    return steps.map(function (step) {
      return config.componentConfigurations[step.componentConfiguration].valueName;
    });
  });
  editValueNames.forEach(function (value) {
    if (!funnelValueNames.includes(value)) {
      throw Error("The \"edit\" configuration contains an invalid entry: The profile property \"".concat(value, "\" is attempted to be edited in the edit configuration but not contained in the funnel config. A property that can not be created, can not be edited."));
    }
  });
};
/**
 * This is a nasty conversion to convert from the backend structure to the enumish value, used in this library
 */


var convertWorkTimes = function convertWorkTimes(workTimesValue) {
  if (Array.isArray(workTimesValue)) {
    return workTimesValue;
  }

  var workTimesArray = []; // default when undefined

  if (typeof workTimesValue === 'undefined') {
    return workTimesArray;
  }

  if (workTimesValue.minimum === 20 || workTimesValue.maximum === 20) {
    workTimesArray.push('PART_TIME');
  }

  if (workTimesValue.maximum === 40 || workTimesValue.minimum === 40) {
    workTimesArray.push('FULL_TIME');
  }

  return workTimesArray;
};

var parseConfigToInitialProfile = function parseConfigToInitialProfile(config, baseProfile) {
  var configFor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'funnel';
  var profile = {
    discriminator: config === null || config === void 0 ? void 0 : config.discriminator
  };
  var configSteps = (config || {})[configFor] || [];
  configSteps.forEach(function (funnelSection) {
    funnelSection.steps.forEach(function (stepKey) {
      if (!(config !== null && config !== void 0 && config.componentConfigurations[stepKey.componentConfiguration])) {
        throw Error("Undefined component configuration ".concat(stepKey.componentConfiguration));
      }

      var step = {
        component: config.componentConfigurations[stepKey.componentConfiguration].component,
        componentConfiguration: (0, _extends2.default)({}, config.componentConfigurations[stepKey.componentConfiguration])
      }; // Here we can hydrate the initial value with the value from the baseProfile, if given

      var defaultValue = baseProfile && (Array.isArray(baseProfile[step.componentConfiguration.valueName]) ? baseProfile[step.componentConfiguration.valueName].length > 0 : baseProfile[step.componentConfiguration.valueName]) ? // We might need to convert worktimes if they are delivered from the backend
      step.componentConfiguration.valueName === 'workTimes' ? convertWorkTimes(baseProfile[step.componentConfiguration.valueName]) : baseProfile[step.componentConfiguration.valueName] : step.componentConfiguration.defaultValue;
      profile[step.componentConfiguration.valueName] = {
        valueType: step.componentConfiguration.valueType,
        value: defaultValue,
        touched: []
      }; // Do we have any sub components?

      Object.entries(step.componentConfiguration).filter(function (_ref2) {
        var _ref3 = (0, _slicedToArray2.default)(_ref2, 1),
            key = _ref3[0];

        return ['selectBox'].includes(key);
      }).forEach(function (_ref4) {
        var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
            key = _ref5[0],
            value = _ref5[1];

        profile[value.valueName] = {
          valueType: value.valueType,
          value: value.defaultValue,
          touched: []
        };
      });
    });
  });
  return profile;
};

var convertEmptyLocationToNull = function convertEmptyLocationToNull(profile) {
  return (0, _extends2.default)({}, profile, {
    location: profile.location.name !== '' ? profile.location : null
  });
};

var stripProfileOfValueTypes = function stripProfileOfValueTypes(profileWithValueTypes) {
  var profileWithoutValueTypes = {
    // Explicitly pass the discriminator, since it would otherwise be erased
    discriminator: profileWithValueTypes.discriminator
  };
  Object.keys(profileWithValueTypes) // Filter for entries with a sub value to avoid overriding special cases with undefined
  .filter(function (key) {
    return typeof profileWithValueTypes[key].value !== 'undefined';
  }).forEach(function (key) {
    profileWithoutValueTypes[key] = profileWithValueTypes[key].value;
  });
  return profileWithoutValueTypes.location ? convertEmptyLocationToNull(profileWithoutValueTypes) : profileWithoutValueTypes;
};

exports.stripProfileOfValueTypes = stripProfileOfValueTypes;

var notContainedIn = function notContainedIn(arr) {
  return function (element) {
    return arr.indexOf(element) === -1;
  };
};

var diffArrays = function diffArrays(arrA, arrB) {
  return arrA.filter(notContainedIn(arrB)).concat(arrB.filter(notContainedIn(arrA)));
};

var reducer = function reducer(state, action) {
  var _action$type$split = action.type.split(' '),
      _action$type$split2 = (0, _slicedToArray2.default)(_action$type$split, 2),
      prefix = _action$type$split2[0],
      key = _action$type$split2[1]; // It is possible to override the method used to determine equality. This is needed, when the value type is not primitive, since JS does not allow custom object equality


  var equals = action.equals ? action.equals : function (a, b) {
    return a === b;
  };

  switch (prefix) {
    case 'setValue':
    case 'editValue':
      var profile = JSON.parse(JSON.stringify(state.profile));
      var previousProfile = JSON.parse(JSON.stringify(state.previousProfile));

      if (profile[key]) {
        switch (profile[key].valueType) {
          case 'Array':
            {
              var payload = Array.isArray(action.payload) ? action.payload : [action.payload];
              payload.forEach(function (value) {
                // add payload if it is not already part of the array. otherwise delete it
                if (profile[key].value.findIndex(function (curr) {
                  return equals(curr, value);
                }) !== -1) {
                  profile[key].value = profile[key].value.filter(function (element) {
                    return !equals(element, value);
                  });
                } else {
                  profile[key].value.push(value);
                }

                profile[key].touched = prefix === 'setValue' ? profile[key].value.length > 0 : diffArrays(profile[key].value, previousProfile[key].value).length > 0;
              });
              break;
            }

          case 'LanguagesArray':
            {
              var _payload = Array.isArray(action.payload) ? action.payload : [action.payload]; // If we reset all, the component might also hand us the languages with a "NONE" level already set, we need to ignore those


              _payload.filter(function (language) {
                return language.skillLevel !== 'NONE';
              }).forEach(function (language) {
                var element = profile[key].value.find(function (curr) {
                  return curr.name === language.name;
                });
                profile[key].value = profile[key].value.filter(function (curr) {
                  return curr.name !== language.name;
                });
                profile[key].value.push({
                  name: language.name,
                  skillLevel: element && element.skillLevel !== 'NONE' ? 'NONE' : 'A'
                });
                profile[key].touched = prefix === 'setValue' ? profile[key].value.length > 0 : diffArrays(profile[key].value, previousProfile[key].value).length > 0;
              });

              break;
            }

          case 'NumberAndUnitWithOptions':
          case 'FormWithInputs':
            {
              profile[key].value[action.payload.identifier] = action.payload.value;
              profile[key].touched = true;
              break;
            }

          case 'ChoiceOrCustom':
            {
              if (typeof action.payload.choice !== 'undefined') {
                profile[key].value.choice = action.payload.choice;
              }

              if (typeof action.payload.custom !== 'undefined') {
                profile[key].value.custom = action.payload.custom;
              }

              profile[key].touched = true;
              break;
            }

          case 'NumberRange':
            {
              if (action.payload.minimum || action.payload.minimum === 0) {
                profile[key].value.minimum = action.payload.minimum;
              }

              if (action.payload.maximum || action.payload.maximum === 0) {
                profile[key].value.maximum = action.payload.maximum;
              }

              profile[key].touched = true;
              break;
            }

          case 'DiagnosticArray':
            {
              if ('filter' in state.profile[key].value) {
                profile[key].value = state.profile[key].value.filter(function (element) {
                  return element.name !== action.payload.name;
                });
              } else {
                profile[key].value = [];
              }

              profile[key].value.push(action.payload);
              profile[key].touched.push(action.payload.name);
              break;
            }

          case 'LocationType':
            {
              if (action.payload.latitude) {
                profile[key].value.latitude = action.payload.latitude;
              }

              if (action.payload.longitude) {
                profile[key].value.longitude = action.payload.longitude;
              }

              if (action.payload.focused) {
                profile[key].value.focused = action.payload.focused;
              }

              if (action.payload.hasOwnProperty('name')) {
                profile[key].value.name = action.payload.name;
              }

              if (action.payload.radius) {
                if (action.payload.radius.minimum) {
                  profile[key].value.radius.minimum = action.payload.radius.minimum;
                }

                if (action.payload.radius.maximum) {
                  profile[key].value.radius.maximum = action.payload.radius.maximum;
                }
              }

              profile[key].touched = !!profile[key].value.name && !!profile[key].value.latitude && !!profile[key].value.longitude;
              break;
            }

          case 'Number':
            {
              profile[key].value = action.payload && parseInt(action.payload);
              profile[key].touched = !!profile[key].value || profile[key].value === 0;
              break;
            }

          case 'String':
            {
              profile[key].value = action.payload;
              profile[key].touched = !!profile[key].value;
              break;
            }

          case 'DescriptionString':
            {
              profile[key].value[action.payload.identifier] = action.payload.text;
              if (!!action.payload.text) profile[key].touched.push(action.payload.identifier);
              break;
            }

          case 'Boolean':
            {
              profile[key].value = action.payload === 'true';
              profile[key].touched = true;
              break;
            }

          default:
            throw new Error("Undefined value type: ".concat(profile[key].valueType));
        }
      }

      return {
        profile: (0, _extends2.default)({}, profile),
        previousProfile: (0, _extends2.default)({}, state.previousProfile)
      };

    case 'revert':
      return {
        profile: (0, _extends2.default)({}, state.previousProfile),
        previousProfile: (0, _extends2.default)({}, state.previousProfile)
      };

    case 'init':
      return {
        profile: action.payload,
        previousProfile: action.payload
      };

    default:
      throw new Error("Undefined data reducer action type: ".concat(action.type));
  }
};

var valueIsEmpty = function valueIsEmpty(value, item) {
  if (item.isEmpty instanceof Function) return item.isEmpty(value.value); // prevent mess made from js not knowing how to boolean

  if (value.valueType === 'Boolean') return false; // zero treatment

  if (value.value === 0) return false;
  if (!value.value) return true;
  if (Array.isArray(value.value) && value.value.length === 0) return true;
  return false;
};

var profileIsIncomplete = function profileIsIncomplete(profile, config) {
  if (typeof config === 'undefined' || typeof config.edit === 'undefined') {
    return false;
  }

  return config.edit.reduce(function (result, item) {
    if (result) {
      return result;
    }

    if (item.type !== 'subtitle' && typeof (item || {}).componentConfiguration == 'string') {
      var compConfig = config.componentConfigurations[item.componentConfiguration];

      if (compConfig.valueName && valueIsEmpty(profile[compConfig.valueName], item)) {
        return true;
      }
    }

    return false;
  }, false);
};

var ProfileContext = /*#__PURE__*/_react.default.createContext({});

exports.ProfileContext = ProfileContext;

var ProfileActionsContext = /*#__PURE__*/_react.default.createContext({
  setValue: function setValue() {},
  editValue: function editValue() {},
  getDefault: function getDefault() {
    return '';
  },
  revert: function revert() {},
  isFunnelCompleted: true,
  areAllFunnelsCompleted: true,
  isIncomplete: function isIncomplete() {
    return false;
  },
  getSpecialDefaults: function getSpecialDefaults() {},
  cleanup: function cleanup() {},
  getPlainProfile: function getPlainProfile() {
    return {};
  },
  track: function track() {}
});
/**
 * Generates a key to identify a profile data object
 */


exports.ProfileActionsContext = ProfileActionsContext;

var generateProfileKey = function generateProfileKey(target, discriminator, configKey, funnelName) {
  return "jmm-".concat(target, "-").concat(configKey, "-").concat(funnelName || 'profile', "-data-").concat(discriminator);
};

var ProfileProvider = function ProfileProvider(_ref6) {
  var children = _ref6.children,
      baseProfile = _ref6.baseProfile,
      _ref6$specialDefaults = _ref6.specialDefaults,
      specialDefaults = _ref6$specialDefaults === void 0 ? {} : _ref6$specialDefaults,
      _ref6$stateMode = _ref6.stateMode,
      stateMode = _ref6$stateMode === void 0 ? 'persistent' : _ref6$stateMode,
      _ref6$dataMode = _ref6.dataMode,
      dataMode = _ref6$dataMode === void 0 ? 'create' : _ref6$dataMode,
      _ref6$configKey = _ref6.configKey,
      configKey = _ref6$configKey === void 0 ? 'funnel' : _ref6$configKey,
      _ref6$configurationCo = _ref6.configurationContext,
      configurationContext = _ref6$configurationCo === void 0 ? _ConfigProvider.ConfigurationContext : _ref6$configurationCo,
      _ref6$funnelName = _ref6.funnelName,
      funnelName = _ref6$funnelName === void 0 ? 'profile' : _ref6$funnelName,
      _ref6$track = _ref6.track,
      track = _ref6$track === void 0 ? function () {} : _ref6$track;

  var _useContext = (0, _react.useContext)(configurationContext),
      config = _useContext.config,
      configurationLoaded = _useContext.configurationLoaded;

  var parentProfile = (0, _react.useContext)(ProfileContext);

  var _useContext2 = (0, _react.useContext)(ProfileActionsContext),
      parentCleanup = _useContext2.cleanup,
      parentFunnelCompleted = _useContext2.areAllFunnelsCompleted,
      getPlainParentProfile = _useContext2.getPlainProfile;

  if (dataMode === 'edit') {
    validateEditConfig(config);
  }

  var initialProfile = (0, _react.useMemo)(function () {
    return parseConfigToInitialProfile(config, baseProfile, configKey);
  }, [baseProfile, config, configKey]);

  var _usePersistentReducer = (0, _usePersistentReducer3.default)(reducer, {
    profile: (0, _extends2.default)({}, initialProfile, {
      _parent: parentProfile
    }),
    previousProfile: (0, _extends2.default)({}, initialProfile)
  }, // Ensure, that we only rehydrate with profiles that are valid for the current version
  stateMode === 'persistent' && configurationLoaded && config ? generateProfileKey(config.target, config.discriminator, configKey, funnelName) : undefined, {
    recoverConfig: {
      mode: 'URL',
      param: 'control'
    }
  }),
      _usePersistentReducer2 = (0, _slicedToArray2.default)(_usePersistentReducer, 3),
      profile = _usePersistentReducer2[0],
      dispatch = _usePersistentReducer2[1],
      cleanupPersistence = _usePersistentReducer2[2];

  var setValue = (0, _react.useCallback)(function (key, value, equals) {
    dispatch({
      type: "setValue ".concat(key),
      payload: value,
      equals: equals
    });
  }, [dispatch]);
  var getSpecialDefaults = (0, _react.useCallback)(function () {
    return specialDefaults;
  }, [specialDefaults]);
  var editValue = (0, _react.useCallback)(function (key, value) {
    dispatch({
      type: "editValue ".concat(key),
      payload: value
    });
  }, [dispatch]);
  var revert = (0, _react.useCallback)(function () {
    dispatch({
      type: 'revert'
    });
  }, [dispatch]);
  var getDefault = (0, _react.useCallback)(function (valueName, identifier) {
    var isGenerated = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    if (isGenerated) {
      return specialDefaults && specialDefaults.names.getName(context);
    } else if (specialDefaults && specialDefaults[valueName]) {
      if (identifier && specialDefaults[valueName][identifier]) {
        return specialDefaults[valueName][identifier](stripProfileOfValueTypes(profile.profile));
      } else {
        return specialDefaults[valueName](stripProfileOfValueTypes(profile.profile));
      }
    }
  }, [profile.profile, specialDefaults]);
  var isIncomplete = (0, _react.useCallback)(function () {
    return profileIsIncomplete(profile.profile, config);
  }, [profile.profile, config]);
  var cleanup = (0, _react.useCallback)(function () {
    var all = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    cleanupPersistence(all);
    parentCleanup(all);
  }, [cleanupPersistence, parentCleanup]);
  var isFunnelCompleted = (0, _react.useMemo)(function () {
    return testFunnelCompleted(profile.profile);
  }, [profile.profile]);
  var getPlainProfile = (0, _react.useCallback)(function () {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (parent > 0) {
      return getPlainParentProfile(parent - 1);
    }

    return stripProfileOfValueTypes(profile.profile);
  }, [profile.profile, getPlainParentProfile]);
  var internalTrack = (0, _react.useCallback)(function (type, data) {
    return track((0, _extends2.default)({}, data, {
      type: type
    }));
  }, [track]);
  var actions = (0, _react.useMemo)(function () {
    return {
      setValue: setValue,
      editValue: editValue,
      revert: revert,
      isFunnelCompleted: isFunnelCompleted,
      areAllFunnelsCompleted: isFunnelCompleted && parentFunnelCompleted,
      getDefault: getDefault,
      isIncomplete: isIncomplete,
      getSpecialDefaults: getSpecialDefaults,
      cleanup: cleanup,
      getPlainProfile: getPlainProfile,
      track: internalTrack
    };
  }, [setValue, editValue, revert, getDefault, isIncomplete, isFunnelCompleted, parentFunnelCompleted, getSpecialDefaults, cleanup, getPlainProfile, internalTrack]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ProfileContext.Provider, {
    value: profile.profile,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ProfileActionsContext.Provider, {
      value: actions,
      children: children
    })
  });
};

exports.ProfileProvider = ProfileProvider;